export type InteractionsFiltersDomain = {
  page: number
  take: number
  includeOlder: boolean
  order?: 'ASC' | 'DESC'
  columnFilters: Record<string, string[]>
}

export function getValidInteractionFilters(filters: InteractionsFiltersDomain) {
  const activeColumnFilters = Object.fromEntries(
    Object.entries(filters.columnFilters).filter(([, values]) => {
      if (!values?.length) return false
      return !(values.length === 1 && String(values[0] ?? '').trim() === '')
    }),
  )

  return {
    page: filters.page,
    take: filters.take,
    order: filters.order ?? 'DESC',
    includeOlder: filters.includeOlder,
    ...(Object.keys(activeColumnFilters).length
      ? { columnFilters: activeColumnFilters }
      : {}),
  }
}
